
import { MapLocation } from '@/types/location';

// Ress Gaming Center Locations
export const ressGamingCenters: MapLocation[] = [
  {
    id: 42001,
    name: "Ress Gaming Center - Riyadh (An Nasim Al Gharbi)",
    type: "Game Center",
    devices: 4,
    coordinates: [24.7406215769972, 46.80477079325297],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Unisex",
    ageRange: "9-30",
    orientation: "Portrait",
    segment: "Game"
  }
];
